import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

import pagination from '@/components/paginationSimple/index.vue';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';
import errorIntellegenceItem from '@/components/dashboard/errorIntellegenceItem/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

import {
  ROLE_QA_EXPERT,
  ROLE_PROOF_READER,
  ROLE_PROJECT_MNG,
} from '@/utils/const';

export default Vue.extend({
  mixins: [
    helpers.work_with_date,
  ],
  components: {
    Multiselect,
    DatePicker,
    pagination,
    preloader,
    empty,
    errorIntellegenceItem,
  },
  data () {
    return {
      errorIntelligenceData: [],
      responseData: {},

      filter: {
        industryFieldList: [],
        textCategoryList: [],
        qaMethodsList: [],
        qaEvaluationTypeList: [],
        errorCategoryList: [],
        statusList: [{
          ID: 'non-modified',
          Name: 'Non-modified',
        }, {
          ID: 'modified',
          Name: 'Modified',
        }],
        roleList: [{
          ID: ROLE_PROJECT_MNG,
          Name: 'Project manager',
        }, {
          ID: ROLE_PROOF_READER,
          Name: 'Proofreader',
        }, {
          ID: ROLE_QA_EXPERT,
          Name: 'QA Expert',
        }],
        errorSeverityList: [{
          ID: 1,
          Name: 'Minor',
        }, {
          ID: 2,
          Name: 'Major',
        }],
        errorMetaRulesList: [],
        proofreadersList: [],
        qaExpertsList: [],
        errorPoints: [],
        metarulesList: [],
        managerList: [],
      },

      params: {
        CreationDate: Array(),
        Proofreaders: Array(),
        IndustryField: Array(),
        QaModels: Array(),
        // Customers: '',
        QaExperts: Array(),
        DocType: Array(),
        QaEvaluationType: Array(),
        GlobalSearch: '',
        Role: '',
        ErrorSeverity: '',
        ErrorPoints: '',
        Status: '',
        // ErrorWeight: '',
        ErrorCategory: '',
        ErrorMetaRules: '',

        LangSearch: {
          Field: '',
          // source / target
          Type: '',
        },
        Manager: '',
      },

      query: {
        Page: 1,
        Ppage: 4,
      },

      pagination: {
        page: 1,
        ppage: 10,
      },

      checkbox: {
        Role: false,
        ErrorSeverity: false,
        ErrorPoints: false,
        Status: false,
        weight: false,
        ErrorCategory: false,
        ErrorMetaRules: false,
        expression: false,
        source: false,
        target: false,
      },

      showMoreFilter: false,

      showMoreBlock: false,

      load: true,

      showAnimation: false,
      sort: {
        field: '',
        direction: '',
      },
    };
  },
  created () {
    this.resetData();

    this.getFilters().then(() => {
      this.getErrorEntelligence();
    });
  },
  methods: {

    getFilters () {
      return Promise.all([
        Api.user
          .getManagers()
          .then((data) => {
            if (data.data.Status) {
              this.filter.managerList = data.data.Data;
            }
          }),
        Api.dashboard
          .getDocType()
          .then((data) => {
            if (data.data.Status) {
              this.filter.textCategoryList = data.data.Data;
            }
          }),

        this.$store.dispatch('GET_INDUSTRY').then((data) => {
          this.filter.industryFieldList = data;
        }),

        Api.getQaMethods()
          .then((data) => {
            if (data.data.Status) {
              this.filter.qaMethodsList = data.data.Data;
            }
          }),

        Api.getMetrics()
          .then((data) => {
            if (data.data.status) {
              this.filter.qaEvaluationTypeList = data.data.ListValue;

              var maxErrorPoints = Math.max.apply(Math, this.filter.qaEvaluationTypeList.map(function (item) { return item.MaxErrorPoint; }));

              for (let i = 0; i <= maxErrorPoints; i++) {
                this.filter.errorPoints.push({
                  ID: i,
                  Name: i + ' points',
                });
              }
            }
          }),

        Api.settings.errorConfiguration
          .get()
          .then((data) => {
            if (data.status) {
              this.filter.errorCategoryList = data.data.Data;
            }
          }),

        Api.dashboard.errorIntelligence
          .getUser()
          .then((data) => {
            if (data.data.Status) {
              data.data.Data.forEach((item) => {
                if (item.Role === ROLE_PROOF_READER) {
                  this.filter.proofreadersList.push(item);
                }
                if (item.Role === ROLE_QA_EXPERT) {
                  this.filter.qaExpertsList.push(item);
                }
              });
            }
          }),

        Api.getMetarules()
          .then((data) => {
            if (data.data.Status) {
              data.data.Data.forEach((item) => {
                var jsonMetarules = JSON.parse(item.CodeShortName);
                var stringMetarules = '';

                jsonMetarules.forEach((valJsonMetarules) => {
                  stringMetarules += '<span class="rules-item">' + valJsonMetarules.CodeName + '</span>';
                });

                this.filter.metarulesList.push({
                  'ID': item.ID,
                  'Name': stringMetarules,
                });
              });
            }
          }),
      ]);
    },

    getErrorEntelligence () {
      this.load = true;
      Api.dashboard.errorIntelligence
        .get(this.transformParams())
        .then((data) => {
          if (data.data.Status) {
            this.errorIntelligenceData = Array();
            this.errorIntelligenceData = [...data.data.Data];

            this.responseData = data.data;

            this.errorIntelligenceData.forEach((item) => {
              item.ParseProjectData = JSON.parse(item.ProjectData);
            });

            if (this.showAnimation) {
              setTimeout(() => {
                this.$refs.scrollTo.scrollIntoView({
                  behavior: 'smooth',
                });

                this.showAnimation = false;
              }, 600);
            } else {
              this.showAnimation = false;
            }
          }
          this.load = false;
        });
    },
    sortHandler(type) {
      if (this.sort.field === type) {
        if (this.sort.direction === 'desc') {
          this.sort.field = '';
          this.sort.direction = '';
        } else {
          this.sort.direction = 'desc';
        }
      } else {
        this.sort.field = type;
        this.sort.direction = 'asc';
      }
      this.getErrorEntelligence();
    },

    gotoBottom () {
      var element = document.getElementById('scroll-to');
      element.scrollTop = element.scrollHeight - element.clientHeight;
    },

    transformParams () {
      let output = Object();
      if (this.params.CreationDate) {
        output.CreationDate = this.convertDatePickerInUnix(this.params.CreationDate);
      }
      ['IndustryField', 'QaModels', 'DocType', 'QaEvaluationType'].forEach((key) => {
        if (this.params[key].length > 0) {
          output[key] = this.params[key].map((el) => el.ID).join(',');
        }
      });
      if (this.params.Manager) {
        output.Manager = this.params.Manager.ID;
      }
      ['Proofreaders', 'QaExperts'].forEach((key) => {
        if (this.params[key].length > 0) {
          output[key] = this.params[key].map((el) => el.UserId).join(',');
        }
      });
      if (this.params.GlobalSearch) {
        if (this.checkbox.target || this.checkbox.source) {
          output.LangSearch = {
            Field: this.params.GlobalSearch,
            Type: this.checkbox.target ? 'target' : 'source',
          };
        } else {
          output.GlobalSearch = this.params.GlobalSearch;
        }
      }
      Object.keys(this.checkbox).forEach((key) => {
        if (this.checkbox[key] && this.params[key]) {
          output[key] = this.params[key].ID;
        }
      });
      output.SortDirection = this.sort.direction;
      output.SortField = this.sort.field;
      output = { ...output, ...this.pagination };

      return output;
    },
    changeSearchLang (type) {
      this.checkbox[type] ? this.params.LangSearch.Type = type : this.params.LangSearch.Type = '';
      type === 'source' ? this.checkbox['target'] = false : this.checkbox['source'] = false;
    },

    sendFilters () {
      this.pagination.page = 1;
      this.resetData();
      this.getErrorEntelligence();
    },

    exportError () {
      this.$root.$emit('notification', {
        message: 'In developing',
        type: 'attention',
        show: true,
      });
    },

    printError () {
      window.print();
    },

    clearFilter () {
      this.params = {
        CreationDate: '',
        Proofreaders: '',
        IndustryField: '',
        QaModels: '',
        QaExperts: '',
        DocType: '',
        QaEvaluationType: '',
        GlobalSearch: '',
        Role: '',
        ErrorSeverity: '',
        ErrorPoints: '',
        Status: '',
        ErrorCategory: '',
        ErrorMetaRules: '',
        LangSearch: {
          Field: '',
          Type: '',
        },
      };

      this.checkbox = {
        statement: false,
        severity: false,
        errorPoints: false,
        status: false,
        weight: false,
        category: false,
        rule: false,
        expression: false,
        source: false,
        target: false,
      };

      this.query.Page = 1;
      this.resetData();
      this.getErrorEntelligence();
    },

    resetData () {
      this.load = true;
      this.errorIntelligenceData = [];
      this.responseData = [];
    },
  },
});
